/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export default interface Brands {
  brandImage: any;
  title: string;
  metadata ? : any;
}

export const Props = {
  brandImage: Object,
  title: String,
  metadata: Object,
}

export const WrapperProps = {
  brandImage: Object,
  title: String,
  metadata: Object,
}

export class BrandsBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class BrandsInstance implements Brands {
      title: string;
      brandImage: any;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

      }
    }
    return new BrandsInstance(props);
  }
}
